export const setSince = ({ since }) => state => {
  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      since: since || state.since,
    },
  };
};
